export default {
  locale: "en",
  name: "Services",
  translation: { displayName: "Translations" },
  fields: {
    list: [],
    form: [],
  },
};
